import { render, staticRenderFns } from "./PassPay.vue?vue&type=template&id=74420abd&scoped=true"
import script from "./PassPay.vue?vue&type=script&lang=js"
export * from "./PassPay.vue?vue&type=script&lang=js"
import style0 from "./PassPay.vue?vue&type=style&index=0&id=74420abd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74420abd",
  null
  
)

export default component.exports